module.exports = __webpack_public_path__ + "static/media/S (165).4465ae46.jpg";